const getHashrateValueWithUnit = (
  value: number,
  magnitude = 0,
  units: Array<string> = ['k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'],
  unit = '',
  nextUnit = '',
):{unit: string, magnitude: number, nextUnit: string, coefficient: number} => {


  value = isNaN(value) ? 0 : value;

  if(2 === magnitude % 3){
    nextUnit = units.shift() ?? 'Out of scope';
  }

  if(Math.pow(10, magnitude) > value / 10){
    return {
      coefficient: Math.pow(10, magnitude - magnitude % 3),
      magnitude: Math.pow(10, magnitude),
      nextUnit,
      unit,
    };
  }

  // recursive function, watch out
  return getHashrateValueWithUnit(
    value,
    magnitude + 1,
    units,
    nextUnit,
    nextUnit,
  );
};

export default getHashrateValueWithUnit;